import { withPackContext } from "../../hoc/withPackContext"
import React, { useMemo } from "react"
import { Col, Row } from "react-bootstrap"

const Service = ({ option, packContext }) => {
  const { packs, duration } = packContext
  const allServices = useMemo(() => extractAllServices(packs, duration), [packs, duration])

  return allServices.map((service) => (
    <Row className="warranty-table" noGutters key={service.label}>
      <Col className="align-self-center text-left">{service.label}</Col>
      <Col
        className={
          option.servicePackDTO.services.map((s) => s.serviceId).includes(service.serviceId)
            ? "warranty-included col-auto"
            : "warranty-not-included col-auto"
        }
      />
    </Row>
  ))
}

export function extractAllServices(packs, duration) {
  return packs
    .filter((pack) => pack.rentDTO.duration === duration)
    .reduce((services, pack) => {
      // eslint-disable-next-line array-callback-return
      pack.servicePackDTO.services.map((service) => {
        if (!services.map((s) => s.serviceId).includes(service.serviceId) && service.displayPdi) {
          services.push(service)
        }
      })
      return services
    }, [])
}

export default withPackContext(Service)
